const { createSelector } = require('reselect');
const { userSelector } = require('selectors/user/userSelector');

const isSDUFeatureDownSelector = createSelector(userSelector, user => user.isSDUFeatureDown);

module.exports = { isSDUFeatureDownSelector };
